<template>
  <div class="order">
    <van-nav-bar title="住读生考勤" left-arrow @click-left="$router.go(-1)" />
    <van-cell title="选择日期" :value="starttime" @click="showDate('start')" />
    <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" :show-confirm="false" />
    <van-button type="primary" class="search-btn" block @click="getList">开始查询</van-button>


    <div class="kq_title">
      <p>早上出寝</p>
      <p>总人数: {{ 0 }}</p>
    </div>
    <van-cell title="未签" is-link :value="list.morning.unsign.length" @click="goList(list.morning.unsign)" />
    <van-cell title="已签" is-link :value="list.morning.sign.length" @click="goList(list.morning.sign)" />

    <div class="kq_title">
      <p>中午归寝</p>
      <p>总人数: {{ 0 }}</p>
    </div>
    <van-cell title="未签" is-link :value="list.noon_in.unsign.length" @click="goList(list.noon_in.unsign)" />
    <van-cell title="已签" is-link :value="list.noon_in.sign.length" @click="goList(list.noon_in.sign)" />

    <div class="kq_title">
      <p>中午出寝</p>
      <p>总人数: {{ 0 }}</p>
    </div>
    <van-cell title="未签" is-link :value="list.noon_out.unsign.length" @click="goList(list.noon_out.unsign)" />
    <van-cell title="已签" is-link :value="list.noon_out.sign.length" @click="goList(list.noon_out.sign)" />
    <div class="kq_title">
      <p>晚上归寝</p>
      <p>总人数: {{ 0 }}</p>
    </div>
    <van-cell title="未签" is-link :value="list.evening.unsign.length" @click="goList(list.evening.unsign)" />
    <van-cell title="已签" is-link :value="list.evening.sign.length" @click="goList(list.evening.sign)" />
  </div>
</template>

<script>

import { zhuduGetAttendancData } from '@/api/teacher'
export default {
  name: 'zhuduAccessRecord',
  components: {},
  data() {
    return {
      show: false,
      starttime: new Date().toLocaleDateString(),
      datetype: '',
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2040, 0, 31),
      page: 1,
      list: {
        morning: {
          sign: [],
          unsign: []
        },
        noon_in: {
          sign: [],
          unsign: []
        },
        noon_out: {
          sign: [],
          unsign: []
        },
        evening: {
          sign: [],
          unsign: []
        }
      },
      currentClass: {}
    }
  },
  mounted() {
    this.currentClass = JSON.parse(localStorage.getItem('currentClass'))
    this.getList()
  },
  methods: {
    async getList() {
      if (!this.starttime) {
        this.$toast('请选择开始结束日期')
        return
      }
      let params = {
        starttime: this.starttime,
        number: this.currentClass.number
      }
      const response = await zhuduGetAttendancData(params)
      console.log('response', response);
      if (response.code == 10000) {
        this.list = response.data
      }
    },
    showDate(type) {
      this.datetype = type
      this.show = true
    },

    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      if (this.datetype === 'start') {
        this.starttime = this.formatDate(date);
      }
    },
    goList(data) {
      if (data.length == 0) {
        this.$toast('暂无数据')
        return
      }
      console.log('data', data)
      this.$router.push({ path: '/detail_list', query: { data: JSON.stringify(data) } })
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}

.search-btn {
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}

.kq_title{
  padding: 10px 10px;
  font-size: 12px;
  color: grey;
}
</style>
